type StorageItem<T> = {
    value: T;
    createdAt: number;      // timestamp (ms)
    expirySeconds?: number; // opsiyonel, saniye cinsinden
};

type ValidationResult<T> = {
    validated: boolean;
    value: T | null;
};

/**
 * Storage içindeki item'ı kontrol eder, expiry süresini geçip geçmediğine bakar.
 */
export const storageValidator = <T>(data: StorageItem<T> | null): ValidationResult<T> => {
    if (!data) return { validated: false, value: null };

    const now = Date.now();

    if (data.expirySeconds && now - data.createdAt > data.expirySeconds * 1000) {
        // süre dolmuş
        return { validated: false, value: null };
    }

    return { validated: true, value: data.value };
};

/**
 * LocalStorage'dan "akıllı" okuma yapar.
 * - Expiry süresini kontrol eder
 * - Eğer geçerli ise value döner
 * - Geçersiz veya yoksa null döner
 */
export const getSmartStorageItem = (key: string): string | null => {
    const datam = localStorage.getItem(key);

    // JSON parse güvenli
    let parsed: StorageItem<string> | null = null;
    try {
        parsed = datam ? JSON.parse(datam) : null;
    } catch (e) {
        console.warn(`getSmartStorageItem: ${key} parse hatası`, e);
        return null;
    }

    const result = storageValidator(parsed);
    return result.validated ? result.value : null;
};

/**
 * LocalStorage'a "akıllı" setleme fonksiyonu
 * - value ile birlikte createdAt ve expirySeconds kaydeder
 */
export const setSmartStorageItem = (key: string, value: string, expirySeconds?: number) => {
    const storageData: StorageItem<string> = {
        value,
        createdAt: Date.now(),
        expirySeconds,
    };
    localStorage.setItem(key, JSON.stringify(storageData));
};

/**
 * LocalStorage'dan silme fonksiyonu
 */
export const removeSmartStorageItem = (key: string) => {
    localStorage.removeItem(key);
};
